import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import type { HistoryItem } from '@/services/loanEmailHistoryService';
import { historyStatus, historyTime } from './historyFormat';

export function HistoryRow(
  { item, onDetails, children }: {
    item: HistoryItem;
    onDetails: (button: HTMLButtonElement) => void;
    children?: ReactNode;
  }
) {
  return (
    <li className='grid min-w-0 items-center gap-3 border-b py-4 last:border-0 md:grid-cols-[minmax(0,1fr)_10rem_10rem_5rem]'>
      <div className='min-w-0 space-y-1 break-words'>
        <p className='text-xs text-muted-foreground'>
          Email · {item.direction === 'inbound' ? 'Inbound' : 'Outbound'}
        </p>
        <p className='font-medium'>{item.subject || 'No subject'}</p>
        {item.isTest && <Badge variant='outline'>Test send</Badge>}
        <p className='text-xs text-muted-foreground'>To: {item.toEmails.join(', ') || 'Not recorded'}</p>
        {item.ccEmails.length > 0 && (
          <p className='text-xs text-muted-foreground'>CC: {item.ccEmails.join(', ')}</p>
        )}
      </div>
      <Badge variant='outline' className='w-fit whitespace-normal'>{historyStatus(item)}</Badge>
      <time dateTime={item.createdAt} className='text-xs text-muted-foreground'>
        {historyTime(item.createdAt)}
      </time>
      <Button
        variant='outline'
        size='sm'
        aria-label={`Details: ${item.subject || 'No subject'}`}
        onClick={(event) => onDetails(event.currentTarget)}
      >
        Details
      </Button>
      {children && <div className='min-w-0 md:col-span-4'>{children}</div>}
    </li>
  );
}
